import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import ExpandableButton from './ExpandableButton';

export const FilterExpandableButton = ({ filterCount, onClick }: { filterCount: number; onClick: () => void }) => {
  return (
    <div className="relative">
      <ExpandableButton icon={faFilter} onClick={onClick}>
        <p className="text-sm">Filters</p>
      </ExpandableButton>
      {filterCount > 0 ? (
        <div className="absolute -top-1.75 -right-1.75 flex size-4 items-center justify-center rounded-full border border-teal-300 bg-teal-100 text-xs text-teal-900">
          {filterCount}
        </div>
      ) : null}
    </div>
  );
};
